import { c as _c } from "react/compiler-runtime";
import Section from "@components/Section";
import { Title } from "@justhome/react-ui";
import { ComponentSectionsCustomerReviews, Trustpilot } from "@lib/generated/graphql";
import Image from "next/image";
import { FC } from "react";
import CustomerReviewsItem from "./CustomerReviewsItem";
export interface CustomerReviewsProps {
  data: ComponentSectionsCustomerReviews;
  staticData: Trustpilot;
  index: number;
}
const CustomerReviews: FC<CustomerReviewsProps> = t0 => {
  const $ = _c(17);
  const {
    data,
    staticData
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Title className="mb-3xs text-d3 text-center">Unsere Kunden über ```Justhome```</Title>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== staticData.score) {
    t2 = <span className="font-medium">{staticData.score}</span>;
    $[1] = staticData.score;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== staticData.numberOfReviews) {
    t3 = <a href="https://de.trustpilot.com/review/justhome.com" target="blank" rel="noopener noreferrer" className="underline font-medium">{staticData.numberOfReviews}</a>;
    $[3] = staticData.numberOfReviews;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Image src="/assets/img/trustpilot-logo.svg" height="32" width="100" alt="Trustpilot Logo" className="inline-block h-3s object-contain align-sub" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3) {
    t5 = <p className="mb-m text-center">Bewertet mit {t2} von 5, basierend auf{" "}{t3}{" "}Bewertungen auf{" "}{t4}</p>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== staticData.trustpilotReviews?.data) {
    t6 = staticData.trustpilotReviews?.data.map(_temp);
    $[9] = staticData.trustpilotReviews?.data;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <div className="grid grid-cols-1 m:grid-cols-2 gap">{t6}</div>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== data || $[14] !== t5 || $[15] !== t7) {
    t8 = <Section section={data} className="my-2s m:my-3s bg-primary-50 py-3m m:py-3xl">{t1}{t5}{t7}</Section>;
    $[13] = data;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default CustomerReviews;
function _temp(review) {
  return review.attributes && <CustomerReviewsItem key={review.id} data={review.attributes} />;
}